/**
 * Utility function to open the Zendesk chat widget
 */
export const openChat = () => {
  try {
    // Check if Zendesk widget is loaded
    if (window.zE && typeof window.zE === 'function') {
      // Try different Zendesk API methods (they vary by widget version)
      try {
        window.zE('webWidget', 'open');
      } catch (e1) {
        try {
          window.zE('messenger', 'open');
        } catch (e2) {
          // If both fail, try to show/activate
          try {
            window.zE('webWidget', 'show');
            window.zE('webWidget', 'activate');
          } catch (e3) {
            console.warn('Could not open Zendesk widget with available methods');
          }
        }
      }
    } else if (window.$zopim && typeof window.$zopim.livechat === 'object') {
      // Fallback for older Zendesk Chat widget
      window.$zopim.livechat.window.show();
    } else {
      // Wait for widget to load and try again
      console.warn('Zendesk widget not loaded yet. Attempting to load...');
      setTimeout(() => {
        if (window.zE && typeof window.zE === 'function') {
          try {
            window.zE('webWidget', 'open');
          } catch (e) {
            window.zE('webWidget', 'show');
          }
        } else {
          console.warn('Chat widget not found. Please ensure the Zendesk script is loaded.');
        }
      }, 1000);
    }
  } catch (error) {
    console.error('Error opening chat widget:', error);
  }
};
